import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

function LoginCard() {
    const { setIsLoggedIn, userData } = useContext(AuthContext);

    // Función para cerrar sesión
    const handleLogout = () => {
        setIsLoggedIn(false);
    };

    return (
        <>
            <div className='auteco_login-card'>
                <div className='datos-contenedor'>
                    <div className="inicial">{userData?.nombres.charAt(0).toUpperCase()}</div>
                    <div>
                        <div className='nombre'>{userData?.nombres} {userData?.apellidos}</div>
                        <div className='email'>{userData?.email}</div>
                    </div>
                </div>
                <div className='icono'>
                    <div className="material-symbols-outlined" onClick={handleLogout} title='Cerrar sesión'>logout</div>
                </div>
            </div>
        </>
    );
}

export default LoginCard;
